import { UseTabs } from "@/common/composition/use-tabs";
import { once } from "@/fp";
import { ref } from "@vue/composition-api";
import { DynamicsTableType, DownloadLog } from "./model";
import { get_table_config } from "./table.config";
import { UseCollection } from "@/common/composition/use-collection";
import { get_finding_entities } from "@/common/api/findings/findings.api";
import { SharedState } from "@/common/state";
import { state as data_source_state } from "@/views/customize/data-sources/data/state";
type DynamicsTab = {
  id: DynamicsTableType;
  name: string;
  icon: string;
  disable: boolean;
  soon: boolean;
};
const dynamics_session_id = ref(-1);

const [tabs, selected_tab, _set_selected_tab] = UseTabs<DynamicsTab>(
  [
    {
      id: "downloads",
      name: "Download Logs",
      icon: "Clock",
      disable: false,
      soon: false,
    },
    {
      id: "top-employees",
      name: "Top Employees",
      icon: "User",
      disable: true,
      soon: true,
    },
    {
      id: "top-views",
      name: "Top views",
      icon: "Detection",
      disable: true,
      soon: true,
    },
  ],
  0
);

const table_config = ref(get_table_config("downloads"));

const {
  items,
  is_loading,
  load_items,
  load_more_items,
  has_no_results,
} = UseCollection<DownloadLog, { cursor: string; session_id: number }>(
  // @ts-ignore
  async ({ cursor, session_id }) => {
    return await get_finding_entities("Dynamics")({
      application: "msft_dynamics_sales",
      service: "msft_dynamics",
      cursor,
      type: "data_exfiltration",
      label_ids: SharedState.dynamics_labels.value.map((d) => d.id),
      axis_z: {
        type: "Session",
        value: session_id,
      },
    });
  }
);

const set_selected_tab = async (tab: DynamicsTab) => {
  _set_selected_tab(tab);
  table_config.value = get_table_config(tab.id);
  await load_items({ cursor: "", session_id: dynamics_session_id.value });
};

const set_the_ongoing_dynamics_session_id = async () => {
  const sessions_res = await data_source_state.ext.get_sessions_for_source(
    "msft_dynamics"
  );
  if (sessions_res.success) {
    const active_session = sessions_res.value.find((f) => f.status == "Opened");
    if (active_session) {
      dynamics_session_id.value = +active_session.id;
    }
  }
};

const init = once(async () => {
  await set_the_ongoing_dynamics_session_id();
  // TODO: get the time frame for 2476
  await load_items({ cursor: "", session_id: dynamics_session_id.value });
});

export const state = {
  is_loading,
  init,
  tabs,
  selected_tab,
  set_selected_tab,
  table_config,
  items,
  load_more_items,
  has_no_results,
};
